import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Pipe({
  name: "safeStyle",
  standalone: true,
})
export class SafeStylePipe implements PipeTransform {
  private sanitizer: DomSanitizer;

  public constructor() {
    this.sanitizer = inject(DomSanitizer);
  }

  public transform(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustHtml(url);
  }
}
